import { useSearchParams } from 'react-router-dom';
import { C, alpha } from '../lib/theme.js';
import { Ads } from './Ads.js';
import { Media } from './Media.js';

/**
 * Library — the single "your stuff" surface. Posts (finished, ready to boost)
 * are the star; raw Photos & clips live behind a drawer toggle. Which view is
 * showing lives in the URL (?view=media) so deep links and the back button work.
 * Each inner surface (Ads / Media) still owns its own params (?creative=, ?stage=).
 */
export function Library() {
  const [params, setParams] = useSearchParams();
  const view = params.get('view') === 'media' ? 'media' : 'posts';

  const setView = (v: 'posts' | 'media') => {
    const next = new URLSearchParams(params);
    if (v === 'media') next.set('view', 'media');
    else next.delete('view');
    // Leaving a view drops its inner params so the other view starts clean.
    next.delete('creative');
    next.delete('stage');
    setParams(next);
  };

  const seg = (v: 'posts' | 'media', label: string, sub: string) => {
    const on = view === v;
    return (
      <button
        type="button"
        onClick={() => setView(v)}
        style={{
          display: 'flex',
          flexDirection: 'column',
          gap: 2,
          padding: '9px 16px',
          borderRadius: 10,
          cursor: 'pointer',
          fontFamily: 'inherit',
          textAlign: 'left',
          border: `1px solid ${on ? C.basil : C.line}`,
          background: on ? alpha(C.basil, 12) : C.surface,
          color: on ? C.basil : C.secondary,
        }}
      >
        <span style={{ fontSize: 13, fontWeight: 600 }}>{label}</span>
        <span
          style={{
            font: `500 10px 'IBM Plex Mono',monospace`,
            color: on ? alpha(C.basil, 75) : C.faint,
          }}
        >
          {sub}
        </span>
      </button>
    );
  };

  return (
    <div>
      <div
        style={{
          display: 'flex',
          gap: 8,
          alignItems: 'center',
          padding: '16px 30px 0',
        }}
      >
        {seg('posts', 'Posts', 'Finished, ready to boost')}
        {seg('media', 'Photos & clips', 'Your raw images & video')}
      </div>
      {view === 'posts' ? <Ads /> : <Media />}
    </div>
  );
}
